export default "__VITE_ASSET__ymY0Al1a__"